<script>
import { HorizontalBar } from "vue-chartjs";

export default {
  extends: HorizontalBar,
  props: {
    chartData: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      chartDataset: {
        labels: [
          "No Poverty",
          "Zero Hunger",
          "Good Health & Well-being",
          "Quality Education",
          "Gender Equality",
          "Clean Water & Sanitation",
          "Affordable & Clean Energy",
          "Decent Work & Economic Growth",
          "Industry, Innovation & Infrastructure",
          "Reduced Inequality",
          "Sustainable Cities & Communities",
          "Responsible Consumption & Production",
          "Climate Action",
          "Life Below Water",
          "Life On Land",
          "Peace, Justice & Strong Institutions",
          "Partnerships for the Goals",
          "Navigate Post-Factual Society",
          "Balance Human & Artificial Intelligence",
          "Trust, Tolerance & Empathy",
          "Innovative Financial System",
          "Refugees and Migrants"
        ],
        datasets: [
          {
            data: this.chartData,
            backgroundColor: [
              "#e62d2c",
              "#e83434",
              "#ea3c3c",
              "#ec4444",
              "#ee4c4c",
              "#f05454",
              "#f25c5c",
              "#f46464",
              "#f66c6c",
              "#f87474",
              "#fa7c7c",
              "#fc8484",
              "#fa7c7c",
              "#f87474",
              "#f66c6c",
              "#f46464",
              "#f25c5c",
              "#f05454",
              "#ee4c4c",
              "#ec4444",
              "#ea3c3c",
              "#e83434",
              "#e62d2c"
            ],
            borderColor: "rgba(0, 0, 0, 0)"
          }
        ]
      },
      chartOptions: {
        layout: {
          padding: {
            right: 15
          }
        },
        legend: {
          display: false
        },
        scales: {
          xAxes: [
            {
              display: false
            }
          ],
          yAxes: [
            {
              gridLines: {
                display: false
              }
            }
          ]
        },
        onClick: this.selectGoal,
        onHover: function(e) {
          let point = this.getElementAtEvent(e);
          if (point.length) e.target.style.cursor = "pointer";
          else e.target.style.cursor = "default";
        },
        tooltips: {
          enabled: false
        },
        plugins: {
          datalabels: {
            display: c => {
              let index = c.dataIndex;
              let value = c.dataset.data[index];
              return value != 0;
            },
            align: "end",
            offset: c => {
              let chart = c.chart;
              let area = chart.chartArea;
              let meta = chart.getDatasetMeta(c.datasetIndex);
              let model = meta.data[c.dataIndex]._model;
              let left = Math.max(model.base, area.left);
              let width = model.x - left;

              return width / 2;
            }
          }
        }
      }
    };
  },
  methods: {
    selectGoal(event, array) {
      let clickedId = array[0]["_index"] + 1;
      let index = this.$store.state.filters.goal.indexOf(clickedId);
      if (index > -1) this.$store.state.filters.goal.splice(index, 1);
      else this.$store.state.filters.goal.push(clickedId);
    }
  },
  mounted() {
    this.renderChart(this.chartDataset, this.chartOptions);
  },
  watch: {
    chartData() {
      this.chartDataset.datasets[0].data = this.chartData;
      this.$data._chart.update();
    }
  }
};
</script>